import './index.css';
import './responsive.css';

import FeaturesSection from '../FeaturesSection';
import ARSection from '../ARSection';
import DataDeploySection from '../DataDeploySection';
import DownloadSection from '../DownloadSection';
import StoriesSection from '../StoriesSection';
import FormSection from '../FormSection';
import FooterSection from '../FooterSection';

function ContentSection(props) {
  const isContentLoaded = (props.contentLoaded === true) ? "show" : "";
  
  return (
    <div className={`features-content-osl3uq ${isContentLoaded} `}>
      <div className="boxed">                
        <FeaturesSection />
        <ARSection />
        <DataDeploySection />
        <DownloadSection />
      </div>

      <StoriesSection />
      <FormSection />
      <FooterSection />
    </div>
  );
}

export default ContentSection;